// extracted by mini-css-extract-plugin
export var mdx = "index-module--mdx--q0W2s";